import JRResume from '../MyResume.jpg'
import React from "react";
import './resume.css';
const Myresume = (props) => {
  return(
   //<img src = {JRResume}></img>
<div className="popup-box">
      <div className="box">
        <span className="close-icon" onClick={props.handleClose}>x</span>
        {props.content}
        <img src = {JRResume}></img>
      </div>
    </div>
  )
}
 
export default Myresume